import React, { useState } from 'react';
import { Button, Container } from '../../../components';
import { IoMdAdd } from 'react-icons/io';
import { RxCross2 } from 'react-icons/rx';
import CreateTermsAndConditions from './CreateTermsAndConditions';
import TermsAndConditionsTable from './TermsAndConditionsTable';
import { useTermsAndConditions } from '../../../context/termsAndConditionContext/TermsAndConditionContextProvider';

const TermsAndConditionsView = () => {
  const [showTACForm, setShowTACForm] = useState(false); // State to toggle form visibility
  const { clearFormData } = useTermsAndConditions(); // Use context to manage terms and conditions data

  const toggleTermsScreen = () => {
    setShowTACForm(!showTACForm); // Toggle form visibility
    if (showTACForm) {
      clearFormData(); // Clear form data when closing the form
    }
  };

  const showForEdit = () => {
    setShowTACForm(true); // Show form for editing
    window.scrollTo(0, 0);
  };

  return (
    <Container title="Terms and Conditions">
      <div className="flex lg:flex justify-end mx-5 lg:gap-5 gap-2 mt-3">
        <Button onClick={toggleTermsScreen}>
          <div>
            {!showTACForm
              ? 'Create Terms and Conditions'
              : 'Close Terms and Conditions'}
          </div>
          <div>
            {!showTACForm ? (
              <IoMdAdd />
            ) : (
              <RxCross2 className="hover:rotate-12" />
            )}
          </div>
        </Button>
      </div>
      <div
        className={`transition-all duration-500 ease-in-out transform ${
          showTACForm ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
        }`}
      >
        {showTACForm && (
          <CreateTermsAndConditions showTermsScreen={toggleTermsScreen} />
        )}
      </div>
      <TermsAndConditionsTable showForEdit={showForEdit} />
    </Container>
  );
};

export default TermsAndConditionsView;
